<template>
	<div class="erji">
		<div class="container">
			<div class="main">
				<div class="news">
					<div class="news1-1 fl">
						<div class="fmain1 flexslider">
							<ul class="slides">
								<li v-for="(item,index) in recommendList" :key="index" >
									<div class="imgbox_a" @click="toDetal(item)">
										<img :src="icoURL+'storage/'+item.image" alt="">
										<h1 class="tver">{{item.title}}</h1>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="main1-2">
						<div class="main1-2-menu">
							<!-- {{newsMenu}} -->
							<dl>
								<dd v-for="(item,index) in newsMenu" :key="index" :class="{ cur : index === curIndex }" @click="newsTab(item,index)">{{item.name}}</dd>
							</dl>
							<div class="clear"></div>
						</div>
						<div class="main1-2-div">
							<div class="main1-2-list">
								<list :listId="listId" :piece="piece_news"></list>
								<div class="more11"><span class="more11_span" @click="toList2(listId)">更多+</span></div>
							</div>
						</div>
					</div>
					<div class="clear"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '../assets/js/jquery.flexslider.js';
	export default {
	  name: 'news',
		data(){
			return{
				id:'',
				recommend:[],
				recommendString:'23,14,15,16,17,18,19,25',
				recommendList:[],
				newsMenu:[],
				curIndex:0,
				listId:'',
				piece_news:10,
			}
		},
		methods:{
			res_menu(){
				this.axios.get('/api/menus/parentNumber?id='+this.id)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// this.recommend = response.data.reslut;
							this.newsMenu = response.data.reslut;
							this.listId = this.newsMenu[0].id;
							for(var i = 0 ; i < response.data.reslut.length;i++){
								this.recommend.push(response.data.reslut[i].id);
							}
							// this.recommendString = this.recommend.toString();
							this.res_reslut();
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//跳转列表页
			toList2(e){
				// console.log("this.$route",e,this.$route);
				this.$router.push({
					path:'/slider/'+ this.$route.query.category_id +'/elist?category_id=' + e
				})
			},
			res_reslut(){
				this.axios.get("/api/news/featureNews?category_id="+this.recommendString+"&number=5")
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// this.menus = response.data.reslut;
							this.recommendList = response.data.reslut;
							this.$nextTick(() => {
								$(".fmain1").flexslider({
									animation : "fade",
									slideshowSpeed: 4000, //展示时间间隔ms
									animationSpeed:500, //滚动时间ms
									slideshow: true,// 载入页面时，是否自动播放
									controlNav: true,  //指示器
									directionNav: false //方向键
								});
							})
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			newsTab(item,index){
				this.curIndex = index;
				this.listId = item.id;
			},
			//跳转详情页
			toDetal(item){
				console.log('跳转详情页',item);
				this.$router.push({
					path:'/slider/'+ item.parent_id +'/detail',
					query:{
						category_id:item.category_id,
						id:item.id
					}
				})
			}
			
		},
		created() {
			// console.log('252',this.$route.query.id)
			this.id = this.$route.query.category_id;
			this.res_menu();
		},
		mounted(){
		}
	}
</script>

<style>
</style>